module.exports = __webpack_public_path__ + "b5c7cf1c74aa9b19421670f7e0986d67.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/SuisseIntl-Regular.woff2
// module id = 1041
// module chunks = 0